import { createContext, useCallback, useState } from 'react';
import produce from 'immer';
import type { ReactNode } from 'react';

/**
 * 管理SearchParams的context
 */

export const SearchParamsContext = createContext<{
  values: OutofStock.SearchParams;
  updateSearchParams: (params: Partial<OutofStock.SearchParams>) => void;
}>({
  values: {} as OutofStock.SearchParams,
  updateSearchParams: () => {},
});

export const SearchParamsContextProvider = (props: { children: ReactNode }) => {
  const [searchParams, setSearchParams] = useState<OutofStock.SearchParams>({
    status: 1,
    keyword: '',
    estimatedAvailableTimeStart: '',
    estimatedAvailableTimeEnd: '',
    pageNo: 1,
    pageSize: 10,
  });
  const updateSearchParams = useCallback((params: Partial<OutofStock.SearchParams>) => {
    setSearchParams((prev) => {
      return {
        ...prev,
        ...params,
      };
    });
  }, []);
  return (
    <SearchParamsContext.Provider
      value={{
        values: searchParams,
        updateSearchParams,
      }}
    >
      {props.children}
    </SearchParamsContext.Provider>
  );
};

/**
 * 管理 selectedRowKeys 的 context
 */
export const SelectedRowsContext = createContext<{
  values: string[];
  updateSelectedRowKeys: (params: string[]) => void;
}>({
  values: [],
  updateSelectedRowKeys: () => {},
});

export const SelectedRowsContextProvider = (props: { children: ReactNode }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const updateSelectedRowKeys = useCallback((params: string[]) => {
    setSelectedRowKeys(
      produce((draft) => {
        draft.splice(0, draft.length, ...params);
      }),
    );
  }, []);
  return (
    <SelectedRowsContext.Provider
      value={{
        values: selectedRowKeys,
        updateSelectedRowKeys,
      }}
    >
      {props.children}
    </SelectedRowsContext.Provider>
  );
};
